import type { SortingState } from '@tanstack/react-table';
import { Actions } from '../../components/product-table/columns/actions-column';
import { DOH } from '../../components/product-table/columns/doh-column';
import { ItemCode } from '../../components/product-table/columns/item-code-column';
import { ProductNameWithLabels } from '../../components/product-table/columns/product-name-with-labels-column';
import { QOH } from '../../components/product-table/columns/qoh-column';
import { Reorder } from '../../components/product-table/columns/reorder-column';
import { getUnitsSoldColumn } from '../../components/product-table/columns/sales-columns';
import { Type } from '../../components/product-table/columns/simple-columns';
import { Size } from '../../components/product-table/columns/size-column';
import { VendorName } from '../../components/product-table/columns/vendor-name-column';
import { DepartmentFilter } from '../../components/product-table/filters/department-filter';
import { FiltersPopover } from '../../components/product-table/filters/filters-popover';
import { HideDisabledFilter } from '../../components/product-table/filters/hide-disabled-filter';
import { SoldInFilter } from '../../components/product-table/filters/sold-in-filter';
import { VendorNameFilter } from '../../components/product-table/filters/vendor-name-filter';
import { ProductReport } from '../../components/product-table/product-report';
import type { StrictColumnDef } from '../../components/tanstack-table/column';
import type { Product } from '../../data/product';
import type { Filters } from '../../hooks/products';
import { productReportsLayout } from '../../router';

const defaultFilters: Filters = {
  maximumDOH: 5,
  hideDisabled: true,
  soldIn: 90,
};

const unitsSoldColumnFor = (filters: Filters) => getUnitsSoldColumn(filters.soldIn || 90);

const columnsFor = (filters: Filters): StrictColumnDef<Product>[] => [
  VendorName,
  ItemCode,
  ProductNameWithLabels,
  Type,
  Size,
  QOH,
  DOH,
  unitsSoldColumnFor(filters),
  Reorder,
  Actions,
];

// Multi-column sort: VendorName ascending, then unitsSold descending
const sortingFor = (filters: Filters): SortingState => [
  { id: VendorName.id, desc: false },
  { id: unitsSoldColumnFor(filters).id, desc: true },
];

export function LowStockReport() {
  const products = productReportsLayout.useLoaderData();

  return (
    <ProductReport
      products={products}
      title="Low Stock"
      defaultFilters={defaultFilters}
      columns={columnsFor}
      sorting={sortingFor}
      toolbarLeft={
        <FiltersPopover defaultFilters={defaultFilters}>
          <HideDisabledFilter />
          <SoldInFilter />
          <VendorNameFilter products={products} />
          <DepartmentFilter products={products} />
        </FiltersPopover>
      }
    />
  );
}
